
























































import Vue from "vue";
export default Vue.extend({
  name: "ShareModalContent",
  props: {
    recipeTitle: {
      type: String,
      required: false,
    },
    recipeUrl: {
      type: String,
      required: false,
    },
  },
});
